import { Component, Input } from '@angular/core';
import { Placeholder } from '../../models/placeholder.model';
import { Dashboard } from '../../models/dashboard.model';
import { ThresholdChartData } from '../../models/threshold-chart-data.model';

@Component({
    selector: 'app-short-threshold-chart',
    templateUrl: './short-threshold-chart.component.html',
    styleUrls: ['./short-threshold-chart.component.css']
})
export class ShortThresholdChartComponent {

    private static ZERO_BOTTOM_CONSTANT: number = -12.25;

    @Input() set dashboard(dashboard: Dashboard) {
        this._dashboard = dashboard;

        if (!this._dashboard || dashboard.getRevenueCount() == null || !dashboard.getMeasurementPeriod()) {
            this.currentValue = -1;
            return;
        }

        this.currentValue = dashboard.getRevenueCount()! / dashboard.getMeasurementPeriod()!;
    }

    @Input() set data(data: ThresholdChartData[]) {
        let index: number = this.currentValue >= 0 ? data.length - 1 : 0;

        if (index) {
            for (; index >= 0; index--) {
                if (this.currentValue >= data[index].value) {
                    break;
                }
            }
        }

        if (index === 0 || data.length < 3) {
            this._data = data.slice(0, 3).reverse();
            this.currentValueIndex = this._data.length - 1 - index;
        } else if (index === data.length - 1) {
            this._data = data.slice(index - 2, index + 1).reverse();
            this.currentValueIndex = 0;
        } else {
            this._data = data.slice(index - 1, index + 2).reverse();
            this.currentValueIndex = 1;
        }

        if (index < data.length - 1) {
            this.bottom = `${((this.currentValue - data[index].value) / (data[index + 1].value - data[index].value) * 100) + ShortThresholdChartComponent.ZERO_BOTTOM_CONSTANT}%`;
        } else {
            this.bottom = `${50 + ShortThresholdChartComponent.ZERO_BOTTOM_CONSTANT}%`;
        }
    }

    @Input() locale: string;

    currentValue: number;
    currentValueIndex: number = -1;
    bottom: string = `${ShortThresholdChartComponent.ZERO_BOTTOM_CONSTANT}%`;

    private _dashboard: Dashboard | null = null;
    private _data: ThresholdChartData[] = [];

    get data(): ThresholdChartData[] {
        return this._data;
    }

    get placeholders(): Placeholder[] {
        return [
            Placeholder.create("currencyCode", this._dashboard?.getCurrencyCode()),
        ];
    }

}
